import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useStateValue } from '../state'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'
import { DetailInfo } from './DetailInfo'
import { CodeContainer } from './CodeContainer'

export const Details = ({ orderId, coursenum }) => {
  let [currentState, dispatch] = useStateValue()
  useEffect(() => {
    const fetchCodes = async () => {
      let resp = await client.get(endpoints.fetchCodes({ orderId: orderId }))
      dispatch({
        type: 'updateOrderCodes',
        payload: {
          order: resp.data.order,
          codes: resp.data.codes,
        },
      })
    }
    fetchCodes(orderId)
  }, [])
  let order = currentState.order
  let codes = currentState.codes
  return (
    <React.Fragment>
      <Link
        style={{ textDecoration: 'none' }}
        to={`/account/admin_coupons.management/${coursenum}/`}
      >
        <i className="far fa-long-arrow-left mr-3" />
        Back
      </Link>
      <div className="d-flex justify-content-between">
        <h2 className="w-50 mb-0">Order Details</h2>
        <span className="text-muted mt-5">Order #{order ? order.id : ''}</span>
      </div>
      <div className="p-3 mb-5 d-flex rounded bg-white shadow">
        {order && (
          <DetailInfo
            created={order.created}
            coursenum={order.coursenum}
            orderedCourseTitle={order.courseTitle}
            numCodes={order.numCodes}
            contactName={order.contactName}
            contactEmail={order.contactEmail}
            institution={order.institution}
            comments={order.comments}
            poNumber={order.poNumber}
            price={order.price}
            pmtMethod={order.pmtMethod}
            pmtDate={order.pmtDate}
            txnId={order.txnId}
            invoiceNum={order.invoiceNum}
            invoiceStatus={order.invoiceStatus}
            internalNotes={order.internalNotes}
            orderId={orderId}
          />
        )}
      </div>
      <h2 className="mb-0">Codes</h2>
      {codes &&
        codes.map((code, i) => (
          <CodeContainer
            key={i}
            id={code.id}
            code={code.builtCode}
            created={code.created}
            expiration={code.expiration}
            assigned={code.assigned}
            assignedTo={code.assignedTo}
            assignedCourse={code.assignedCourse}
            redeemedOn={code.redeemedOn}
            redeemedBy={code.redeemedBy}
            redeemedCourse={code.redeemedCourse}
            status={code.status}
            orderId={orderId}
            containerMargin={i > 0 ? 'my-5' : null}
          />
        ))}
    </React.Fragment>
  )
}
